import MenuIcon from '@mui/icons-material/Menu';
import { IconButton, Toolbar } from "@mui/material";
import MuiAppBar, { AppBarProps as MuiAppBarProps } from '@mui/material/AppBar';
import { styled } from '@mui/material/styles';
import { drawerWidth } from "./Drawer";
import { PageTitle } from './PageTitle'
import { NavMenu } from './NavMenu'

interface AppBarProps extends MuiAppBarProps {
  open?: boolean;
}

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== 'open',
})<AppBarProps>(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(['width', 'margin'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

type Props = {
  open: boolean;
  isMobile: boolean;
  toggleSidebar: () => void;
}

export const Navbar: React.FC<Props> = ({ open, isMobile, toggleSidebar }) => {
  // On mobile the drawer overlays the page, so the app bar never shifts.
  const shifted = open && !isMobile;
  return (
    <AppBar position="absolute" open={shifted}>
      <Toolbar
        sx={{
          pr: { xs: "12px", sm: "24px" },
        }}
      >
        <IconButton
          edge="start"
          color="inherit"
          aria-label="open drawer"
          onClick={toggleSidebar}
          sx={{
            marginRight: { xs: "12px", sm: "36px" },
            ...(shifted && { display: "none" }),
          }}
        >
          <MenuIcon />
        </IconButton>
        <PageTitle />
        <NavMenu />
      </Toolbar>
    </AppBar>
  );
}
